import { Tabs } from '@tonic/shared/components/ui'
import { TabsList } from '@tonic/shared/components/ui'
import { TabsTrigger } from '@tonic/shared/components/ui'
import { Outlet } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';

export function CustomersLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname.split('/')[2] || '';

  const handleTabChange = (value) => {
    switch (value) {
      case 'list':
        navigate('/admin/customers');
        break;
      case 'segments':
        navigate('/admin/customers/segments');
        break;
      case 'analytics':
        navigate('/admin/customers/analytics');
        break;
      default:
        navigate('/admin/customers');
    }
  };

  return (
    <div className="flex flex-col h-full">
      <div className="border-b border-neutral-800 px-6 py-4">
        <h1 className="text-2xl font-bold mb-4">Customers</h1>
        <Tabs
          value={
            currentPath === '' ? 'list' :
            currentPath === 'segments' ? 'segments' :
            currentPath === 'analytics' ? 'analytics' : 'list'
          }
          onValueChange={handleTabChange}
        >
          <TabsList>
            <TabsTrigger value="list">All Customers</TabsTrigger>
            <TabsTrigger value="segments">Segments</TabsTrigger>
            <TabsTrigger value="analytics">Analytics</TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
} 
